import React from "react";
import { Layout, Collapse, Row, Col } from "antd";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { BROWSE_CAR } from "../../route/AppRouter";
import { CheckOutlined } from "@ant-design/icons";
import homeimg from "../../assets/images/login.png";
import SEO from "../../components/SEO";

const { Content } = Layout;
const { Panel } = Collapse;

const EasyLease = () => {
  const history = useHistory();

  return (
    <Content className="easyLeaseContainer">
      <SEO
        title="EasyLease"
        description="One-Stop Transport & Finicial Solution"
        path="easylease"
      />
      <Row justify="center" gutter={48} className="whatIsEasylease">
        <Col span={24}>
          <h2 className="sectionTitle">What is Easy Lease?</h2>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
          xxl={{ span: 8 }}
        >
          <div>
            <h3 className="blockTitle text-center">
              One monthly payment to drive
            </h3>
            <p className="blockPara">
              Get a car, servicing and maintenance, and insurance all in one.
            </p>
          </div>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
          xxl={{ span: 8 }}
        >
          <div>
            <h3 className="blockTitle text-center">On your terms</h3>
            <p className="blockPara">
              Pick a contract length, then return, swap or keep it longer. We
              offer flexibility you won't get with other car buying options.
            </p>
          </div>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
          xxl={{ span: 8 }}
        >
          <div>
            <h3 className="blockTitle text-center">All online</h3>
            <p className="blockPara">
              That really is everything. No nasty surprises. No hidden costs. No
              hassle. Easy Lease!
            </p>
          </div>
        </Col>
      </Row>

      <Row justify="center" gutter={48} className="whatIsEasylease">
        <Col span={24}>
          <h2 className="sectionTitle">Why Yoma Fleet Easy Lease?</h2>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
        >
          <div>
            <ul>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Costeffective way to drive a brand new car
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                6-36 months flexible contract terms
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Fixed monthly payment
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                No residual risk
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Worry-free maintenance
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Full tyre maintenance
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Affordable way to upgrade the newest models every year
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                International Standard Insurance
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Full accident management support
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                24/7 365 help desk
              </li>
            </ul>
          </div>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
        >
          <div>
            <img className="easyleaseImage" src={homeimg} alt="be different" />
          </div>
        </Col>
      </Row>

      <Row justify="center" className="seeSomeCars">
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 12 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
        >
          <h3 className="sectionTitle">Want to see some cars?</h3>
          <input
            className="seeSomeCarsTitleBrowse"
            type="submit"
            value="Let's Browse"
            onClick={() => history.push(BROWSE_CAR)}
          />
        </Col>
      </Row>

      <Row justify="center" className="whatIsInclude">
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
        >
          <h3 className="sectionTitle">What’s included? </h3>
          <p className="sectionPara text-center">
            There are no hidden costs when you drive with Yoma Fleet Easy Lease{" "}
          </p>
          <div className="table-wrapper">
            <table cellPadding="20">
              <tr>
                <td></td>
                <th>Hire Purchase</th>
                <th>Finance</th>
                <th>Purchase</th>
                <th>Easy Lease</th>
              </tr>

              <tr>
                <th>Comprehensive insurance</th>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CheckCircleOutlined />
                </td>
              </tr>

              <tr>
                <th>Full servicing and maintenance </th>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CheckCircleOutlined />
                </td>
              </tr>

              <tr>
                <th>Cancel anytime</th>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CheckCircleOutlined />
                </td>
              </tr>

              <tr>
                <th>Online application process</th>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CloseCircleOutlined />
                </td>
                <td>
                  <CheckCircleOutlined />
                </td>
              </tr>
            </table>
          </div>
        </Col>
      </Row>

      <Row justify="center" className="whatIsEasyleaseFaq">
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
        >
          <h1 className="sectionTitle">FAQ</h1>
          <p className="sectionPara text-center">
            Here are few common questions
          </p>

          <Collapse defaultActiveKey={["1"]}>
            <Panel
              header="How does insurance works with Yoma Fleet Easy Lease? "
              key="1"
            >
              <p className="paragraph">
                Comprehensive insurance coverage is included with all Yoma Fleet
                Easy Lease vehicle contracts.{" "}
              </p>
              <p className="paragraph">
                The period that you are covered is linked exactly with your
                contract period.
              </p>
              <p className="paragraph">
                The non-deductible excess in the event of loss or damage, unless
                recovered from a third party, is MMK 200,000.{" "}
              </p>
            </Panel>
            <Panel
              header="Does Yoma Fleet provide a replacement vehicle if I have an accident?"
              key="2"
            >
              <p className="paragraph">
                In the event of an accident where there has been no illegal use,
                Yoma Fleet will provide a similar replacement vehicle whilst
                your vehicle is in the panel shop for repair.{" "}
              </p>
            </Panel>
            <Panel header="What if I want to cancel or early return? " key="3">
              <p className="paragraph">
                You will be subject to a cancellation fee, which is 20% of the
                remaining payments on your contract, with a minimum charge of
                one full month.{" "}
              </p>
              <p className="paragraph">
                For more detail on cancellations, just get in touch with our
                team.{" "}
              </p>
            </Panel>
            <Panel header="How does the approval process work? " key="4">
              <p className="paragraph">
                We ask you to complete our standard credit application form and
                supply scanned copies of necessary documents. This will allow us
                to identify you and assess your ability to pay. None of this
                information will be shared with any third parties.{" "}
              </p>
              <p className="paragraph">
                To obtain a Yoma Fleet Easy lease vehicle you will need to pass
                the credit application process. If you don’t pass, we won’t be
                able to move forward with your Easy Lease.{" "}
              </p>
              <p className="paragraph">
                Still have questions? Please contact us by email
                at aung@yomafleet.com or via the chat function on our website
                and we'll be delighted to help.{" "}
              </p>
            </Panel>
          </Collapse>
        </Col>
      </Row>
    </Content>
  );
};

export default EasyLease;
